const queryUtil = {
  /*
   * Remove multiple instances question marks (?) in query param
   *
   * @param {string} queryParam - the query parameter
   * @returns {string}
   */
  cleanQueryParams(queryParam: string) {
    return queryParam.replace(/\?/g, '&').replace('&', '?');
  },

  isAlphaNumeric(ch: string) {
    return ch.match(/^[a-z0-9]+$/i) !== null;
  },

  /*
   * examples:
   * www.url.com/ -> www.url.com
   * www.url.com/?foo=bar -> www.url.com?foo=bar
   * www.url.com/?foo=bar/ -> www.url.com?foo=bar
   */
  parseExtraSlashes(url: string) {
    const regex = new RegExp('\\/\\?|\\/\\&', 'g');
    let statusCode = 200;

    if (url.match(regex)) {
      url = url.replace(regex, '?');
      statusCode = 301;
    }

    if (url.substr(url.length - 1) === '/') {
      url = url.slice(0, -1);
      statusCode = 301;
    }

    return {
      statusCode,
      url,
    };
  },

  sanitize(obj: { [key: string]: string } = {}) {
    const newQueryObj: { [key: string]: string } = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key]) {
        // remove everything past ?
        if (obj[key].lastIndexOf('?') > -1) {
          obj[key] = obj[key].substr(0, obj[key].lastIndexOf('?'));
        }
        newQueryObj[encodeURIComponent(key)] = encodeURIComponent(obj[key]);
      }
    }

    return newQueryObj;
  },

  // @ts-expect-error
  stringify(obj) {
    const str = [];
    let p;

    for (p in obj) {
      if (obj.hasOwnProperty(p) && (obj[p] || obj[p] === false)) {
        str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
      }
    }

    if (str.length > 0) {
      return `?${str.join('&')}`;
    }
    return '';
  },
};

export default queryUtil;
